import React, { useEffect } from 'react';
import HomeSlider from '../Component/HomeSlider'
import TopperXII from '../Component/TopperXII'
import TopperX from '../Component/TopperX' 
import Events from '../Component/Events'
import News from '../Component/News'
import Calender from '../Component/Calender' 
import Birthday from'../Component/Birthday'
import Gallery from '../Component/Gallery'
import Message from '../Component/Message'  
import { Link } from 'react-router-dom'
import ClassTabs from '../Component/ClassTabs' 
import Header from'../Component/Header'; 
import LazyLoad from 'react-lazyload'
import Campuscare from'../Component/Campuscare'
import Popup from '../Component/Popup';
const Home = () => {
  useEffect(() => {
    document.title = ' Home - Sacread Heart Kharagpur';  
}); 
  return (
    <>
    <Header/> 
      <HomeSlider />
      <Campuscare/>
      <Popup/>
      <div className="aboutmidsec padded-sec">
        <div className='button'>
          <Link to="/Admission">
            <p> Admission</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/" target='_blank'>
            <p>online payment</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="PrincipalMessage">
            <p>Principal Message</p></Link>
        </div>
        <div className='phone'>
          <Link to="tel:03222 256266">
            <LazyLoad><img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/phone.gif" alt="SHCSKWB" /></LazyLoad>
          </Link>
        </div>
        <div className='button'>
          <Link to="/Fees">
            <p>Fees</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/Examination">
            <p> Examination</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/Uniform">
            <p>Uniform</p>
          </Link>
        </div>
      </div>
      <div className="aboutsec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 about-bg">
              <div class="about-news">
                <div className='title'>
                  <p>about us</p>
                  <h2>Sacred heart school, kharagpur</h2>
                </div>
                 <div className="aboutbox">
                 <p> After the completion of primary schooling, the children could not carry on with their studies, due to non availability of English medium school, the need for a high school was felt, hence Fr. John Turner with the help of a couple of college going students, began the high school in 1969. </p> <p> St. Agnes School came forward to help the boys of Sacred Heart High School. The newly set up High School was an extension of St. Agnes School. Later Sr. Yvette A.C. became the Principal of the boys section of St. Agnes School; later Fr. John Turner took charge of the school. Land was petitioned from the Railways, different donors came forward with financial help for the construction of the school building, and a huge structure came up. On 10th December 1987 foundation stone was laid for the science block, under the able guidance of Fr Joy. C. DSouza, who was then the Principal. The new block was inaugurated on 16 August 1990 </p> <p> From January 1971, Sacred Heart got separated from St. Agnes boys section, and was recongized as Sacred Heart Higher Secondary School, with science stream. The ISC section with Commerce stream was introduced in 1996; In 2006 the high school began admitting girls. </p> <p> The School is recognized by the Education Department, Government of West Bengal, under the Anglo Indian Board of West Bengal and affiliated to the Council For Indian School Certificate Examinations, New Delhi </p>
                 </div>
                <Link to="/AboutUs"><button className='button'>Read More</button></Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-img">
                
                <div className='center-img'> <LazyLoad><img src='https://webapi.entab.info/api/image/SHCSKWB/public/Images/aboutimg.png' className='abs-img3 img-fluid' alt="SHCSKWB" /></LazyLoad></div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='classSection'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <ClassTabs />

            </div>

          </div>
        </div>
      </div>
      <div className='calender'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='title'>
                <h2>Academic Year </h2>
              </div>
              <Calender />

            </div>

          </div>
        </div>
      </div>
      <div className="event">
        <div className="container fulwidth">
          <div className="row">
            <div className="col-lg-12 section-title">
              
            </div>
            <div className="col-lg-12">
              <Message />
            </div>
          </div>
        </div>
      </div>
      <div className='events padded-sec'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xl-6 col-md-12'>
            <div className='title'> 
                <h2>Events section</h2>
              </div>
              <Events />
            </div>
            <div className='col-xl-6 col-md-12'>
            <div className='title'> 
                <h2>Latest News/Announcement</h2>
              </div>
              <News />
            </div>
          </div>
        </div>
      </div>
      <div className="topper_bg padded-sec">
        <div className="container-fluid section-title">
          <div className="row"> 
             <div className="col-lg-9">
                  <div className='title'> 
                    <h2> Toppers section</h2>  
                  </div>
                  <div className="row">
                  <div className="col-lg-6">
                  <div className='topper-block'>
                     <h6>TOPPER X</h6>
                  <TopperX />
                  </div>
                  <button className='button'><Link to="/Toppers">Read More</Link></button> 
                </div>  
                <div className="col-lg-6">
                  <div className='topper-block'>
                  <h6>TOPPER XII</h6>
                  <TopperXII />
                  </div>
                   <button className='button'><Link to="/ToppersXII">Read More</Link></button> 
                </div>
                  </div>
             </div>
            <div className="col-lg-3">
            <div className='title'> 
                <h2>BIRTHDAY section</h2> 
              </div>
              <div className='topper-block'>
             
                 <Birthday/>
              </div> 
            </div>
          </div>
        </div>
      </div>  
      <div className="homegallery padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className='col-md-12 section-title'>
              <div className='title'> 
              <LazyLoad><img src='https://webapi.entab.info/api/image/SHCSKWB/public/Images/gal.gif' className='img-fluid' alt="SHCSKWB" /></LazyLoad>
                <h2>Activities in Images</h2>
              </div>
            </div>
            <div className="col-lg-12">

              <Gallery />
              <button className='button'><Link to="/Gallery">Read More</Link></button>
            </div>
          </div>
        </div>
      </div> 
     
    </>
  )
}

export default Home